import * as React from "react";
import { useState } from "react";
import { technika } from "./Data";
import "./Cards.css";
import Counter4 from "./Counter4";

export default function MediaCard() {
  const [card, setCard] = useState(-1);
  var myArray = technika;
  var rand = myArray[(Math.random() * myArray.length) | 0];

  const nextCardOnClick = () => {
    setCard((prev) => (prev + 1) % 3);
  };

  return (
    <div className="card">
      <h4 className="title">TECHNIKA</h4>
      <p>{rand}</p>
      <div className="buttons">
        <Counter4 />
        <button className="btn" onClick={nextCardOnClick}>
          Następne pytanie
        </button>
      </div>
    </div>
  );
}
